var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1554_19176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 8C17.8333 9.01205 17.8333 12.9807 16.5 14",
    stroke: "#C1C7D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6097 5.04744L6.5 8.04861V13.9514L12.6097 16.9526C12.7082 16.9924 12.8151 17.0075 12.9209 16.9965C13.0267 16.9856 13.1282 16.949 13.2162 16.8899C13.3043 16.8308 13.3763 16.751 13.4258 16.6578C13.4753 16.5645 13.5008 16.4605 13.5 16.3552V5.64483C13.5008 5.53945 13.4753 5.43552 13.4258 5.34224C13.3763 5.24897 13.3043 5.16924 13.2162 5.11014C13.1282 5.05104 13.0267 5.0144 12.9209 5.00346C12.8151 4.99252 12.7082 5.00763 12.6097 5.04744Z",
    stroke: "#C1C7D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8H4.21429C3.75963 8 3.32359 8.18507 3.0021 8.5145C2.68061 8.84394 2.5 9.29074 2.5 9.75663V12.2434C2.5 12.7093 2.68061 13.1561 3.0021 13.4855C3.32359 13.8149 3.75963 14 4.21429 14H6.5",
    stroke: "#C1C7D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1554_19176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileNotifications);
export default __webpack_public_path__ + "static/media/profile-notifications.6f780b32fe3c4a34e5aa6f257a86d5d1.svg";
export { ForwardRef as ReactComponent };